import React from 'react';

export const EyeStars = () => (
  <svg width="140" height="98" viewBox="0 0 140 98" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M74.0966 86.8269C91.7219 86.8269 106.01 72.5388 106.01 54.9135C106.01 37.2881 91.7219 23 74.0966 23M74.0966 86.8269C56.4712 86.8269 42.1831 72.5388 42.1831 54.9135C42.1831 37.2881 56.4712 23 74.0966 23M74.0966 86.8269C115.92 86.8269 139.293 54.9135 139.293 54.9135C139.293 54.9135 115.92 23 74.0966 23M74.0966 86.8269C32.2728 86.8269 8.90039 54.9135 8.90039 54.9135C8.90039 54.9135 32.2728 23 74.0966 23M74.0966 70.8175C82.8801 70.8175 90.0006 63.6971 90.0006 54.9135C90.0006 46.1299 82.8801 39.0094 74.0966 39.0094M74.0966 70.8175C65.313 70.8175 58.1925 63.6971 58.1925 54.9135C58.1925 46.1299 65.313 39.0094 74.0966 39.0094M74.0966 70.8175C77.8194 70.8175 80.8374 63.6971 80.8374 54.9135C80.8374 46.1299 77.8194 39.0094 74.0966 39.0094M74.0966 70.8175C70.3737 70.8175 67.3558 63.6971 67.3558 54.9135C67.3558 46.1299 70.3737 39.0094 74.0966 39.0094"
      stroke="#171717"
      strokeWidth="0.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.20703 75V75C7.30502 78.2757 9.94511 80.9041 13.2212 80.9876L13.707 81L13.2212 81.0124C9.94511 81.0959 7.30502 83.7243 7.20703 87V87V87C7.10905 83.7243 4.46895 81.0959 1.19288 81.0124L0.707031 81L1.19288 80.9876C4.46895 80.9041 7.10905 78.2757 7.20703 75V75Z"
      fill="#262626"
    />
    <path
      d="M116.207 86V86C116.305 89.2757 118.945 91.9041 122.221 91.9876L122.707 92L122.221 92.0124C118.945 92.0959 116.305 94.7243 116.207 98V98V98C116.109 94.7243 113.469 92.0959 110.193 92.0124L109.707 92L110.193 91.9876C113.469 91.9041 116.109 89.2757 116.207 86V86Z"
      fill="#262626"
    />
    <path
      d="M25.4004 0V0C25.6642 9.0079 32.92 16.2402 41.9287 16.4747L42.9004 16.5L41.9287 16.5253C32.92 16.7598 25.6642 23.9921 25.4004 33V33V33C25.1366 23.9921 17.8808 16.7598 8.87208 16.5253L7.90039 16.5L8.87208 16.4747C17.8808 16.2402 25.1366 9.0079 25.4004 0V0Z"
      fill="#262626"
    />
  </svg>
);
